import { withDisposableStack } from '@app/packages/disposable/disposable'

export class ScrollPreventer {
  private supportsPassive = false
  private wheelOpt: any = false
  private wheelEvent = 'wheel'
  private disabled = false

  constructor() {
    if (!IS_BROWSER) return
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    try {
      ;(window as any).addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get() {
            that.supportsPassive = true
          },
        })
      )
    } catch {}

    this.wheelOpt = this.supportsPassive ? { passive: false } : false
    this.wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel'
  }

  /** Setup is synchronous, so `using` + `move()` — a failure half way reaches the caller. */
  disableScroll() {
    if (this.disabled) throw new Error('ScrollPreventer: already disabled')

    return withDisposableStack(stack => {
      this.disabled = true
      stack.defer(() => {
        this.disabled = false
      })
      const preventDefault = (e: { preventDefault: () => unknown }) => {
        e.preventDefault()
      }
      window.addEventListener('DOMMouseScroll', preventDefault, false)
      stack.defer(() => {
        window.removeEventListener('DOMMouseScroll', preventDefault, false)
      })
      window.addEventListener(this.wheelEvent, preventDefault, this.wheelOpt)
      stack.defer(() => {
        window.removeEventListener(this.wheelEvent, preventDefault, this.wheelOpt)
      })
      window.addEventListener('touchmove', preventDefault, this.wheelOpt)
      stack.defer(() => {
        window.removeEventListener('touchmove', preventDefault, this.wheelOpt)
      })
    })
  }
}
